/* Native horizontal scrolling; progressive enhancement adds a quiet continuous loop. */
(() => {
  if (window.bbqGalleryReady) return;
  window.bbqGalleryReady = true;
  const initialise = (root = document) => root.querySelectorAll('[data-home-gallery]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const viewport = gallery.querySelector('.home-gallery__viewport');
    const track = gallery.querySelector('.home-gallery__track');
    const group = gallery.querySelector('.home-gallery__group');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let touching = false, focused = false, visible = false, previous = 0, frame = 0, position = 0;
    const clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('img').forEach(img => img.alt = '');
    clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
    track.appendChild(clone);
    const update = () => { clone.hidden = reduced.matches; };
    viewport.addEventListener('pointerdown', () => { touching = true; }, {passive:true});
    const release = () => { touching = false; position = viewport.scrollLeft; };
    viewport.addEventListener('pointerup', release, {passive:true});
    viewport.addEventListener('pointercancel', release, {passive:true});
    viewport.addEventListener('pointerleave', release, {passive:true});
    viewport.addEventListener('focusin', () => { focused = viewport.matches(':focus-visible'); });
    viewport.addEventListener('focusout', () => { focused = false; position = viewport.scrollLeft; });
    reduced.addEventListener('change', update);
    update();
    const animate = now => {
      if (!gallery.isConnected) { observer.disconnect(); reduced.removeEventListener('change', update); return; }
      if (previous && !touching && !focused && !reduced.matches && !document.hidden) {
        position = (position + Math.min(now - previous, 50) * .065) % group.offsetWidth;
        viewport.scrollLeft = position;
      }
      previous = now;
      frame = visible ? requestAnimationFrame(animate) : 0;
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible && !frame) { previous = 0; frame = requestAnimationFrame(animate); }
      else if (!visible && frame) { cancelAnimationFrame(frame); frame = 0; }
    });
    observer.observe(gallery);
  });
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
